export * from "./atoms";
export * from "./organisms";

import { RoomContentAtoms } from "./atoms";
import { RoomContentOrganisms } from "./organisms";

export const RoomContentComponents = [...RoomContentAtoms, ...RoomContentOrganisms];
